(() => {
  const selectors = {
    loadMore: '.load-more',
    loadMoreWrapper: '.load-more-wrapper',
    articlesWrapper: '.articles-wrapper',

    classLoading: 'loading'
}

  document.addEventListener('click', async (e) => {
    if (e.target.matches(selectors.loadMore)) {
      e.target.classList.add(selectors.classLoading)
      const res = await fetch(e.target.dataset.next);
      const text = await res.text();
      const html = document.createElement('div');

      html.innerHTML = text;
      const articles = html.querySelector(selectors.articlesWrapper).innerHTML;
      const loadMoreButton = html.querySelector(selectors.loadMoreWrapper).innerHTML;

      document.querySelector(selectors.articlesWrapper).insertAdjacentHTML('beforeend', articles);
      document.querySelector(selectors.loadMoreWrapper).innerHTML = loadMoreButton;
      await e.target.classList.remove(selectors.classLoading);
    }
  })
})()